<template>
  <div 
    id="drinking_water_ship"
    class="drinking_water"
  >
    <div 
      v-if="receivedData"
      class="drinking_water-item"
    >
      <SelectGraphic 
        :receivedData="receivedData[0]"
        id="drinking_water-1"
      />
    </div> 

    <div 
      v-if="receivedData"
      class="drinking_water-item"
    >
      <CastomGraphic
            :received-data="receivedData[1]"
            graph-type="bar"
            index-axis="y"
            :id="'drinking_water-2'"
            :aspect-ratio="1"
            :stacked="false"
        />
    </div> 
    <div 
      v-if="receivedData"
      class="drinking_water-item"
    >
      <SelectGraphic 
        :receivedData="receivedData[2]"
        id="drinking_water-3"
      />
    </div> 

    <div 
      v-if="receivedData"
      class="drinking_water-item"
    >
      <CastomGraphic
            :received-data="receivedData[3]"
            graph-type="bar"
            index-axis="y"
            :id="'drinking_water-4'"
            :aspect-ratio="1"
            :stacked="false"
        />
    </div> 
  </div>
</template>
<script>

import CMS from '@/model/cms'
import Service from '@/service/service.js'
import { mapGetters } from 'vuex'

export default {
  name: 'DrinkingWater',
  
  components: {
    SelectGraphic: () => import('@/components/graph/SelectGraphic.vue'),
    CastomGraphic: () => import('@/components/graph/CastomGraphic.vue'),
  },

  computed: {
    ...mapGetters({
      userToken: 'getUserToken'
    }),
  },

  data () {
    return {
      receivedData: null,
      blockId: 'drinking_water',
      cloneElementId: 'drinking_water_ship'
    }
  },

  mounted() {
    this.getGraphData()
    Service.elementClone(this.blockId, this.cloneElementId)
  },

  methods: {
    getGraphData() {
      CMS.getGraph(this.userToken, '76,77,78,79,80,81').then((response) => {
        this.receivedData = []
        this.receivedData[0] = response.data.slice(0, 2)
        this.receivedData[1] = response.data[2]
        this.receivedData[2] = response.data.slice(3, 5)
        this.receivedData[3] = response.data[5]
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .drinking_water {
    display: flex;
    flex-direction: column;
    &-item {
      width: 100%;
      margin-right: 20px;
    }
  }
</style>